export const getCommonTimeline = (style, timelineData: string[] = []) => {
    let timeline = {
        axisType: 'category',
        orient: 'horizontal',
        autoPlay: false,
        currentIndex: 0,
        top: 'bottom',
        symbolSize: 8,
        data: timelineData,
        label: {
            fontSize: style.fontSize - 1,
            position: style.fontSize - 1
        },
        checkpointStyle: {
            symbolSize: style.fontSize - 2
        },
        controlStyle: {
            itemSize: style.fontSize - 2,
        },
        symbolKeepAspect: true,
        tooltip: {
            show: true,
            trigger: 'item',
            borderColor: '#7CB5EC',
            borderWidth: 1,
            backgroundColor: 'rgba(247, 247, 247 ,0.85)',
            extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);border-radius:4px',
            textStyle: {
                color: "#333",
                fontSize: 11,
            },
            padding: 8,
            formatter: function (params) {
                params.value = params.value ? params.value : '-'
                let str = '';
                str += '<span style="color:' + params.color + '">' + params.marker + params.name + '</span><br/>'
                return str;
            }

        }
    }
    return timeline;
}